module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-02.076830af.png";